var map = {
	"./24-25/U15_24-25/team.jpg": 6748,
	"./24-25/U16_24-25/team.jpg": 4185,
	"./24-25/U18_24-25/team.jpg": 6955,
	"./24-25/U21_24-25/team.jpg": 9995,
	"./24-25/noi_24-25/team.jpg": 8523,
	"./U16/team.jpg": 2885,
	"./U18/team.jpg": 9099,
	"./U21/team.jpg": 4635,
	"./noi/team.jpg": 1135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3530;